// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-959","productName":"Table_productName__2ILn6"};